<template>
  <div class="new-point" @click="$emit('click', $event)">
    <button type="button">Добавить точку маршрута</button>
  </div>
</template>

<script>
export default {
  name: 'RouteTimelineNewPoint',
  props: { isFirst: { type: Boolean, default: false } },
};
</script>

<style lang="scss" scoped>
.new-point {
  padding: 12px;
  text-align: center;

  button {
    padding: 7px 14px;
    color: #c80c0b;
    border: 1px dashed rgba(200, 12, 11, 0.45);
    border-radius: 8px;
    background: #fff;
    font-weight: 600;

    &:hover {
      background: #fff7f7;
    }
  }
}
</style>
